var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stockScoreDetailRow"},[_c('div',{staticClass:"ssdrName"},[_vm._v(_vm._s(_vm.subScoreName))]),_c('div',{staticClass:"ssdrValue"},[_vm._v(_vm._s(_vm.subScoreValue))])])
}
var staticRenderFns = []

export { render, staticRenderFns }